import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'react-final-form';
import WrappedCodeInput from './WrappedCodeInput';

function FormCodeInput(props) {
  return <Field component={WrappedCodeInput} {...props} />;
}

FormCodeInput.propTypes = {
  name: PropTypes.string.isRequired
};

export default FormCodeInput;



// WEBPACK FOOTER //
// ./src/components/form/FormCodeInput.js